import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

const RAW = {interpolation: {escapeValue: false}};

/**
 * Un prompt de Dashbo en la vidriera: se explora, se vota y, si sirve, se adapta. «Adaptar» crea una
 * copia de TODA la agencia (fork sin cliente) que pasa a la solapa propia y se edita ahí.
 *
 * No se edita desde acá aunque `is_editable` venga en `true` (un SuperAdmin puede editar los
 * oficiales): esta pantalla es de la agencia, y el oficial se edita desde el Command Center.
 */
export function DashboPromptCard({prompt, agencyName, adapting, onAdapt, onSeeAdapted, onView, onRate}) {
    const {t} = useTranslation();
    const social = prompt.social || {thumbs_up: 0, thumbs_down: 0, my_rating: null};
    const tags = [
        prompt.role ? t(`prompt_library.roles.${prompt.role}`) : null,
        ...(prompt.momentos || []).map((momento) => t(`prompt_library.momentos.${momento}`)),
    ].filter(Boolean);

    const voteLabel = (label, count) => (count > 0 ? `${label} · ${count}` : label);

    return (
        <article className="agp-card">
            {tags.length > 0 && (
                <div className="agp-card__tags">
                    {tags.map((tag) => <span key={tag} className="agp-tag">{tag}</span>)}
                </div>
            )}
            <h3 className="agp-card__name">{prompt.title}</h3>
            {prompt.value_preview && <p className="agp-card__preview">{prompt.value_preview}</p>}
            <div className="agp-card__foot">
                {prompt.adapted ? (
                    <button type="button" className="agp-card__adapted" onClick={() => onSeeAdapted(prompt)}>
                        <FaIcon iconName="check"/>
                        {t('agency_prompts.dashbo_adapted', {agency: agencyName, ...RAW})}
                    </button>
                ) : (
                    <button type="button" className="agp-btn -ghost" onClick={() => onAdapt(prompt)} disabled={adapting}>
                        {adapting
                            ? t('agency_prompts.dashbo_adapting')
                            : t('agency_prompts.dashbo_adapt', {agency: agencyName, ...RAW})}
                    </button>
                )}
                <button type="button" className="agp-btn -quiet" onClick={() => onView(prompt)}>
                    {t('agency_prompts.dashbo_view')}
                </button>
                <span className="agp-vote">
                    <button type="button" className={`agp-vote__btn${social.my_rating === 'UP' ? ' -on' : ''}`}
                            aria-pressed={social.my_rating === 'UP'} onClick={() => onRate(prompt, 'UP')}>
                        <FaIcon iconName="thumbs-up"/>
                        {voteLabel(t('agency_prompts.dashbo_vote_up'), social.thumbs_up)}
                    </button>
                    <button type="button" className={`agp-vote__btn${social.my_rating === 'DOWN' ? ' -on -dislike' : ''}`}
                            aria-pressed={social.my_rating === 'DOWN'} onClick={() => onRate(prompt, 'DOWN')}>
                        <FaIcon iconName="thumbs-down"/>
                        {voteLabel(t('agency_prompts.dashbo_vote_down'), social.thumbs_down)}
                    </button>
                </span>
            </div>
        </article>
    );
}
